import React from "react";
import ShortHeaderComponent from "./components/ShortHeaderComponent";
import { Trophy } from "lucide-react";
import ParticipantStatusCard from "./components/ParticipantStatusCard";
import OurCoreValues from "./components/OurCoreValues";
import CurrentMonthWinner from "./components/CurrentMonthWinner";
import PreviousWinner from "./components/PreviousWinner";

const CoreValuesProgram = () => {
  return (
    <div>
      <div className="flex flex-col gap-6">
        <ShortHeaderComponent
          icon={Trophy}
          title={"Core Values Program"}
          description={"Celebrating team members who embody our core values"}
        />
        <ParticipantStatusCard/>
        <OurCoreValues/>
        <CurrentMonthWinner/>
        <PreviousWinner/>
      </div>
    </div>
    
  );
};



export default CoreValuesProgram;
